/**
 * Watches the family's phones (app_devices) and tells the 🔔 bell when one
 * needs attention: alerts blocked, exact alarms off, or no sync for 24 hours,
 * and about today's very high / low blood pressure readings.
 */
import { localTodayISO } from '@bhorosha/core';
import { backend } from '../data';
import { phoneHealth } from './model';

export function startPhoneWatch(familyId: string): () => void {
  let stopped = false;
  const check = async () => {
    try {
      const today = localTodayISO();
      const snap = await backend.loadMonitor(familyId, today, today);
      if (stopped) return;
      const members = window.__bhMembers || [];
      const people = (window.state?.people || []) as { id: string; name: string }[];
      const bpAlerts = snap.bp.filter(r => (r.level === 'very_high' || r.level === 'low') && people.some(p => p.id === r.patientId)).map(r => ({
        key: `bp:${r.id}`, userId: r.loggedBy || '',
        title: `${people.find(p => p.id === r.patientId)?.name || 'Someone'}: ${r.level === 'very_high' ? 'very high' : 'low'} blood pressure`,
        sub: `${r.systolic}/${r.diastolic} at ${new Date(r.measuredAt).toLocaleTimeString('en-GB', { hour: 'numeric', minute: '2-digit', hour12: true })}. Please check on them.`,
      }));
      window.__bhPhoneWarnings = bpAlerts.concat(snap.devices.flatMap(d => {
        const h = phoneHealth(d);
        if (!h.problems.length) return [];
        const who = members.find(m => m.userId === d.userId)?.displayName || 'A family member';
        return [{ key: `phone:${d.userId}:${d.deviceId}:${h.problems.join('|')}`, userId: d.userId || '', title: `${who}'s phone needs attention`, sub: h.problems.join(' · ') }];
      }));
      window.__bhMembersChanged?.();
    } catch { /* migration not run yet, or offline */ }
  };
  void check();
  const iv = setInterval(check, 15 * 60_000);
  const unsub = backend.subscribeMonitor(familyId, () => { void check(); });
  return () => { stopped = true; clearInterval(iv); unsub(); };
}
